import { Badge } from '../ui/badge';

export const RiskBadge = ({ riskLevel, className = '' }) => {
  const riskConfig = {
    low: {
      className: 'bg-green-100 text-green-800 border-green-200',
      label: 'Low Risk'
    },
    medium: {
      className: 'bg-amber-100 text-amber-800 border-amber-200',
      label: 'Medium Risk'
    },
    high: {
      className: 'bg-red-100 text-red-800 border-red-200',
      label: 'High Risk'
    }
  };

  const config = riskConfig[riskLevel?.toLowerCase()] || riskConfig.medium;

  return (
    <Badge 
      className={`${config.className} ${className}`}
      data-testid={`risk-badge-${riskLevel?.toLowerCase()}`}
    >
      {config.label}
    </Badge>
  );
};